/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegistrationsControllerCheckSsoMutationResponse, RegistrationsControllerCheckSso400 } from "../../models/registrationsController/RegistrationsControllerCheckSso";

function getRegistrationsControllerCheckSsoUrl() {
  const res = { method: 'POST', url: `/api/v1/registrations/check-sso` as const }  
  return res
}

/**
 * @description Checks if SSO is required for the organization associated with the email domain.
 * @summary Check if SSO is required for an email address
 * {@link /api/v1/registrations/check-sso}
 */
export async function registrationsControllerCheckSso(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RegistrationsControllerCheckSsoMutationResponse, ResponseErrorConfig<RegistrationsControllerCheckSso400>, unknown>({ method : "POST", url : getRegistrationsControllerCheckSsoUrl().url.toString(), ... requestConfig })  
  return res.data
}